import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/milgro.webp';
import screenshot_target from '../../../images/letterfunnel/laurensgroen.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Laurens Groen"
      firstname="Laurens"
      companyname="Milgro"
      competition="Seenons en Rubicon"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/laurensgroen.js